export default "__VITE_ASSET__52bbda8e__"